import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/posts/components/CategoryFilter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/posts/PostsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LanguageSelector.tsx");
